import { render, staticRenderFns } from "./BattleJoinOrRegister.vue?vue&type=template&id=38492fe8&scoped=true"
import script from "./BattleJoinOrRegister.vue?vue&type=script&lang=js"
export * from "./BattleJoinOrRegister.vue?vue&type=script&lang=js"
import style0 from "./BattleJoinOrRegister.vue?vue&type=style&index=0&id=38492fe8&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38492fe8",
  null
  
)

export default component.exports